import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type State = { renderMode: 'hydrateRoot'; isComplete: boolean } | { renderMode: 'createRoot' };
const DEFAULT_STATE: State = { renderMode: 'createRoot' };
let state: State = Object.freeze(DEFAULT_STATE);

autoBeforeEachTest(() => {
	state = DEFAULT_STATE;
});

// Even though this uses no hooks, we expose it as one to ensure it is only used during render
// (which is the only time we know if we're hydrating)
// For that reason, though, it's important that this never changes value
export const useIsHydrateRenderMode = (): boolean => state.renderMode === 'hydrateRoot';

export const useSsrPlaceholders = (): boolean =>
	state.renderMode !== 'hydrateRoot' || !fg('jfp-magma-data-ssr-placeholder-retain');

/**
 * Indicates that we are rendering React using `hydrateRoot`. This should be called once only early in init before any
 * rendering, since it's assumed to remain constant in {@link useIsHydrateRenderMode}
 */
export const setIsHydrationRenderMode = (): void => {
	state = { renderMode: 'hydrateRoot', isComplete: false };
};

/**
 * Indicates that hydration is finished. Ignored if not in hydrate root mode.
 */
export const reportHydrationEnd = (): void => {
	if (state.renderMode === 'hydrateRoot') {
		state.isComplete = true;
	}
};

export const getIsHydrationInProgress = (): boolean =>
	state.renderMode === 'hydrateRoot' && !state.isComplete;
